import o from "haversine-distance";
const l = 3e4, f = (t, e, n = l) => e ? t.filter(
  (r) => r.locationId !== e?.locationId && c(r, e, n)
) : [], c = (t, e, n = l) => o(
  { lat: t.latitude, lng: t.longitude },
  { lat: e.latitude, lng: e.longitude }
) < n, d = (t) => t ? `${t.name}, ${t.address}` : "", I = (t, e, n) => !e || !n ? [] : t.map((a) => {
  const r = n.find((s) => s.locationId === a.locationId), i = r ? o(
    { lat: r.latitude, lng: r.longitude },
    { lat: e.latitude, lng: e.longitude }
  ) : -1;
  return {
    trailer: a,
    stationName: d(r),
    distanceInMeters: i
  };
}), y = (t, e) => {
  const n = [], a = [];
  for (const r of t)
    r.locationId === e.locationId ? n.push(r) : a.push(r);
  return {
    trailersForStation: n,
    nearbyTrailers: a
  };
};
export {
  I as extendNearbyTrailersWithInfo,
  f as filterStationsByNearbyStation,
  d as getTrailerRentalLocationDisplayName,
  c as isStationsNearby,
  y as separateNearbyTrailersFromSelectedStation
};
